import { c } from '../../../utils/tailwind-merge';
import { EmptyState } from '../../molecules/EmptyState';
import { UserAssetsCollection } from '../../molecules/UserAssetsList/UserAssetsCollection';
import type { PublisherListsProps } from './PublisherLists.types';

export const PublisherLists = ({
  lists,
  microcopy,
  className = '',
}: PublisherListsProps) => {
  if (lists.length === 0) {
    return <EmptyState microcopy={microcopy.emptyState} />;
  }

  return (
    <div className={c('-mx-2 flex flex-wrap', className)}>
      {lists.map((list) => (
        <UserAssetsCollection key={list.link} microcopy={microcopy} {...list} />
      ))}
    </div>
  );
};
